import { TransactionType } from '../../extract/extract.model';
import { PixKeyType } from './key-type.enum';
import { OperationType } from './transaction.model';
import { TransacaoPixValores } from './transfer-return.model';

export class PixReceipt {
	numeroConta: string;
	tipoConta: string;
	agencia: number;
	complemento: string;
	documento: string;
	iSPBCodigo: string;
	iSPBNome: string;
	nome: string;
	codigoTransacao: number;
	dataTransacao: Date;
	dataContabil: Date;
	tipoMovimentacao: string;
	tipoTransacao: TransactionType;
	valor: number;
	codigoChave: string;
	tipoChave: PixKeyType;
	sequencial: number;
	autenticacao: string;
	codigoFimAFim: string;
	codigoFimAFimDevolucao: string;
	descricaoOriginal: string;
	valorOriginal: number;
	dataTransacaoOriginal: Date;
	agendado = false;
	tipoOperacao: OperationType;
	valores: TransacaoPixValores;
	authorized: boolean;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/receipt.model.ts